import {APP_VERSION as version} from 'env';
import {registerServiceWorker} from './serviceWorker';

import {saveVersion} from './saveVersion';
import {isColdStart} from './extractSavedVersion';
import {init} from './coldInitialization';

import {checkRemoteSettings} from './checkRemoteSettings';
import {checkUserTimeZoneShift} from './timeZoneShift';
import {checkCoreDataStructures} from './breakingChanges';

const updateVersion = saveVersion;

(function autoInitEnvironmentPreparation(): void {
  registerServiceWorker();

  if (isColdStart()) {
    init();
    saveVersion(version);
  }

  checkUserTimeZoneShift();
  checkCoreDataStructures();
  checkRemoteSettings();

  updateVersion(version);
})();
